import { render } from "./TechnologiesPage.vue?vue&type=template&id=abcca202&scoped=true"
const script = {}

import "./TechnologiesPage.vue?vue&type=style&index=0&id=abcca202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abcca202"]])

export default __exports__